export default "__VITE_ASSET__5b828132__"